import React from 'react';
import {connect} from 'react-redux';

import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';

class Team extends React.Component {

    render() {
        return <FullWidthPage title="Екип">
            <div className="col-md-12">
                <SectionTitle>За нас</SectionTitle>

                    <p>Ние сме Петър, Невена и Евгений. Космополитни българи, малко идеалисти и луди глави, на които
                        им се
                        занимава със смислени неща с полза за другите. И нашия живот е динамичен и въртележка от
                        преживявания нагоре-надолу - като твоя, но от време на време ние избираме да слезем от нея и
                        да си
                        починем. С медитация. Решихме да подарим това преживяване и на теб.</p>

                    <p>Струва си, опитай!</p>

                    <div className="col-lg-10 col-lg-offset-1">
                        <div className="row team-member">
                            <div className="col-sm-12 col-md-4 side-image col-md-push-8">
                                <img className="team-avatar" src="/img/team/petar.jpg"/>
                            </div>
                            <div className="col-sm-12 col-md-8 col-md-pull-4">
                                <h3 className="title">Петър</h3>
                                <p>Аз съм Петър, ръководител. Отне ми много време докато намеря
                                    проект, който да отговаря на критериите
                                    за успешен продукт. Вярвам, че с това начинание решаваме проблем - липсата на
                                    качествени
                                    медитации
                                    на български език, организирани в модерно приложение. Даваме своя принос за това
                                    нашите
                                    сънародници
                                    да са по-спокойни, уравновесени, устремени и усмихнати, където и да се намират по
                                    света.</p>
                            </div>
                        </div>

                        <div className="row team-member">
                            <div className="col-md-4 side-image">
                                <img className="team-avatar" src="/img/team/nevena.jpg"/>
                            </div>
                            <div className="col-md-8">
                                <h3>Невена</h3>
                                <p>Аз съм Невена и съм творческа и търсеща личност, която не се страхува да се загуби по
                                    пътя
                                    към
                                    поредното откритие. Основната ми роля в проекта е на автор и редактор на текстовете.
                                    За
                                    мен
                                    медитирането е пътуване навътре в себе си, в искрен опит да успокоим бъбривия си ум.
                                    Което
                                    на мен
                                    лично ми носи усещане за вътрешен мир.</p>
                            </div>
                        </div>

                        <div className="row team-member">
                            <div className="col-md-4 side-image col-md-push-8">
                                <img className="team-avatar" src="/img/team/evgeni.jpg"/>
                            </div>
                            <div className="col-md-8 col-md-pull-4">
                                <h3>Евгений</h3>
                                <p>Казвам се Евгений и съм гласът, водещ медитациите. В рамките на този проект ще се
                                    радвам
                                    да
                                    допринеса
                                    за това всеки, желаещ да се занимава с медитация на български език, да намира своите
                                    минути
                                    спокойствие, отпускане и вслушване дълбоко в себе си.</p>
                            </div>
                        </div>
                    </div>
            </div>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(Team);




// WEBPACK FOOTER //
// ./src/components/Pages/Team.js